import React from "react";
import { RoutePath, apiPath } from "../../utilities/Constants";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import { useNavigate } from "react-router-dom";

function AddClientPage() {
  const { clientsApi } = apiPath;
  const { clientList } = RoutePath;
  const navigate = useNavigate();

  //   // Form data
  const data = [
    {
      elementType: "file",
      label: "client image",
      type: "Text",
      name: "image",
      required: false,
      fullCol: true,
    },
    {
      elementType: "textField",
      label: "client name",
      type: "Text",
      name: "name",
      required: false,
    },
  ];

  const update = async (data) => {
    const newData = { clientsImg: [data] };

    const res = await updateData(clientsApi, newData, null, true);
    if (res?.length > 0) {
      setTimeout(() => {
        navigate("/" + clientList);
      }, 1000);
    }
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
}

export default AddClientPage;
